// src/communaute/MessageriePage.jsx
//
// Page « Messagerie » du dashboard créateur, séparée de la page Communauté.
//
// Utilisation (react-router) :
//   <Route path="/messagerie" element={<MessageriePage />} />
//
// Props optionnelles :
//   onOuvrirEvenement(id) → ouvre la fiche d'un événement de ton dashboard
//   convInitialeId        → ouvre directement une conversation (ex. venant d'ailleurs)

import { useEffect, useState } from 'react';
import { FileText, MessageSquare } from 'lucide-react';

import { getPost, getToken } from './api';
import Messagerie from './Messagerie';
import PostCard from './PostCard';
import { Chargement, Modal, UiHost, Vide } from './ui';

export default function MessageriePage({ onOuvrirEvenement, convInitialeId = null }) {
    const [postCible, setPostCible] = useState(null);

    if (!getToken()) {
        return (
            <div className="flex min-h-[60vh] items-center justify-center">
                <Vide icone={MessageSquare} titre="Accès réservé aux membres" sous="Connectez-vous pour accéder à la messagerie" />
            </div>
        );
    }

    return (
        <div className="text-gray-900">
            <div className="mx-auto max-w-6xl">
                <Messagerie
                    convInitialeId={convInitialeId}
                    onOuvrirEvenement={onOuvrirEvenement}
                    onOuvrirPost={(id) => setPostCible({ id, commentaires: false })}
                />
            </div>

            {postCible && <PostModal cible={postCible} onFermer={() => setPostCible(null)} />}
            <UiHost />
        </div>
    );
}

// ══════════════════════════════════════════════════════
//  PUBLICATION OUVERTE DEPUIS UN MESSAGE PARTAGÉ
// ══════════════════════════════════════════════════════
function PostModal({ cible, onFermer }) {
    const [post, setPost] = useState(undefined);

    useEffect(() => {
        let annule = false;
        getPost(cible.id).then((p) => !annule && setPost(p));
        return () => {
            annule = true;
        };
    }, [cible.id]);

    return (
        <Modal ouvert onFermer={onFermer} titre="Publication" taille="lg">
            <div className="p-4">
                {post === undefined ? (
                    <Chargement />
                ) : post === null ? (
                    <Vide icone={FileText} titre="Publication introuvable" sous="Elle a peut-être été supprimée" />
                ) : (
                    <PostCard post={post} ouvrirCommentaires={cible.commentaires} onSupprime={onFermer} />
                )}
            </div>
        </Modal>
    );
}